// extracted by mini-css-extract-plugin
export default {"targetCode":"EditTableModal_targetCode__iOM2w"};